export const archive = "U_yj4b";
export default {archive};